const AddOnIds = {
  CTCT_SMS_ADDON: 'CTCT-SMS-ADDON',
};

export default AddOnIds;
